import { Collapse, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMore from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

type Props = {
  title: string | React.ReactNode;
  defaultOpen?: boolean;
  overrideOpen?: boolean;
} & (
  | { id?: undefined; onStateChange?: undefined; registerKey?: undefined }
  | {
      id: string;
      onStateChange: (id: string, expanded: boolean) => void;
      registerKey: (key: string) => void;
    }
);

const CollapseSection: React.FC<Props> = ({
  children,
  defaultOpen = false,
  overrideOpen = false,
  title,
  id,
  onStateChange,
  registerKey,
}) => {
  const [expanded, setExpanded] = useState(defaultOpen);

  useEffect(() => {
    if (registerKey && id) {
      registerKey?.(id);
    }
    return () => registerKey?.(id ?? '');
  }, [id, registerKey]);

  useEffect(() => {
    setExpanded(overrideOpen);
  }, [overrideOpen]);
  const classes = useStyles();
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {typeof title === 'string' ? (
          <Typography variant="h6">{title}</Typography>
        ) : (
          <>{title}</>
        )}
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={() =>
            setExpanded((p) => {
              if (onStateChange && id) {
                onStateChange(id, !p);
              }

              return !p;
            })
          }
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMore />
        </IconButton>
      </div>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
};

export default CollapseSection;
